import { IconButton, IconButtonProps } from '@mui/material'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'

export type IModalV2 = {
    isTopLayer: boolean
}

export const ModalCloseButton = (args: IconButtonProps) => {
    const disableBtns = useSelector(
        (state: RootState) => state.schoolModal.disableBtns
    )
    return (
        <IconButton
            {...args}
            disabled={disableBtns}
            sx={{
                height: 40,
                width: 40,
            }}
        >
            {/* prettier-ignore */}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18 6L6 18M6 6L18 18" stroke="#555555" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/> </svg>
        </IconButton>
    )
}
